module.exports = __webpack_public_path__ + "img/odd-13.707c6dc2.jpeg";